<template>
    <veui-dialog
        title=""
        ui="auto"
        overlay-class="transfer-dialog"
        :open="true"
        :closable="false"
        footless
    >
        <template #title>
            <div class="title-box">
                <span class="title-text">{{ title }}</span>
                <span @click="close">
                    <veui-icon class="close" name="times"/>
                </span>
            </div>
        </template>
        <div class="main-content-box">
            <veui-form
                :data="formData"
            >
                <veui-field
                    label="原销售"
                    name="name"
                    class="name"
                    :rules="[{name: 'required', triggers: 'blur'}]"
                >
                    <div class="origin-sales-box">
                        <veui-select
                            v-if="!info.id"
                            v-model="formData.oriNameId"
                            class="option"
                            placeholder="请选择要转移前的销售成员"
                            :options="memberList"
                            clearable
                            searchable
                            @change="oriNameChange"
                        />
                        <div
                            v-else
                            class=""
                        >
                            {{ formData.oriName || '无' }}
                        </div>
                    </div>
                </veui-field>
                <veui-field
                    label="新销售"
                    name="newName"
                    class="name"
                    :rules="[{name: 'required', triggers: 'blur'}]"
                >
                    <veui-select
                        v-model="formData.newNameId"
                        class="option"
                        placeholder="请选择要转移后的销售成员"
                        :options="memberList"
                        clearable
                        searchable
                        @change="newNameChange"
                    />
                </veui-field>
            </veui-form>
            <div class="result-tips">
                <div class="result-title">转移结果</div>
                <div
                    v-if="!info.id"
                    :class="['result', formData.oriNameId && formData.newNameId ? '' : 'no-result']"
                >
                    <!-- eslint-disable -->
                    {{ formData.oriNameId && formData.newNameId
                        ? `${formData.oriName}名下共${relativeCount}${this.transType === 4 ? '个' : '人'}将转移至${formData.newName}名下`
                        : `请先选择${formData.oriNameId ? '' : '原销售'}${!formData.oriNameId && !formData.newNameId ? '和' : ''}${formData.newNameId ? '' : '新销售'}`
                    }}
                    <!-- eslint-enable -->
                </div>
                <div
                    v-else
                    :class="['result', formData.newName ? '' : 'no-result']"
                >
                    {{ formData.newName
                        ? `${info.name}将${info.id && !info.firm_subaccount_name
                            ? ''
                            : `从${formData.oriName}名下`}转移至${formData.newName}名下`
                        : '请先选择新销售'
                    }}
                </div>
            </div>
        </div>
        <div class="foot-button">
            <veui-button
                ui="strong"
                @click="close"
            >取消</veui-button>
            <veui-button
                ui="primary"
                class="submit-btn"
                @click="submit"
            >确认转移</veui-button>
        </div>
    </veui-dialog>
</template>

<script>
import {
    Dialog,
    Button,
    Field,
    Form,
    Select,
    Icon
} from 'veui';
import {mapState} from 'vuex';

const URL = {
    // 潜客、客户转移
    transferSubmit: '/bp/crm/trans',
    gettranscnt: '/bp/crm/gettranscnt',
    // 会员工具转移
    utilTrans: '/bp/firmlawyer/trans',
    getVipList: '/bp/firmlawyer/getlawyerinfolist',
    // 会员码转移
    distributeSales: '/bp/api/vip/trans',
    getcode: '/bp/api/vip/getcode'
};

export default {
    name: 'transferCustomer',
    components: {
        'veui-field': Field,
        'veui-form': Form,
        'veui-dialog': Dialog,
        'veui-button': Button,
        'veui-select': Select,
        'veui-icon': Icon
    },
    props: {
        open: {
            'type': Boolean,
            default: false
        },
        info: {
            'type': Object,
            'default': () => {}
        },
        // 1 潜客页面 2 客户页面 0 全部 3 会员权益工具页面 4 会员码转移页面
        transType: {
            'type': Number,
            default: 0
        }
    },
    watch: {
        info: {
            handler(newVal) {
                this.init(newVal);
            },
            deep: true
        },
        'formData.oriNameId'(newVal) {
            if (this.info.id) {
                return;
            }
            // 会员权益工具页面
            if (this.transType === 3) {
                this.getVipToolCount(newVal);
                return;
            }
            // 会员码转移
            else if (this.transType === 4) {
                this.getCodeCount(newVal);
                return;
            }
            this.getRelativeCount();
        }
    },
    computed: {
        ...mapState({
            agentMemberData: state => state.lawStore.agentMemberData || []
        }),
        memberList() {
            let agentMemberData = this.agentMemberData || [];
            agentMemberData.forEach(item => {
                item.label = item.name;
                item.value = item.id;
            });
            return agentMemberData;
        },
        role() {
            let roleInfo = {
                1: '客户',
                2: '客户',
                3: '律师',
                4: '会员码'
            };
            return roleInfo[this.transType] || '';
        },
        title() {
            return !this.info.id ? `批量转移${this.role}` : `转移${this.role}`;
        }
    },
    mounted() {
        this.init(this.info);
    },
    data() {
        return {
            formData: {
                oriName: '',
                oriNameId: null,
                newName: '',
                newNameId: null
            },
            originSalesInfo: {},
            newSalesInfo: {},
            relativeCount: 0
        };
    },
    methods: {
        /**
         * 初始化
         * @param {object} info 初始化信息
         */

        init(info) {
            if (info && Object.keys(info).length) {
                let obj = {};
                // 单个转移时不传id
                obj.oriName = info.firm_subaccount_name;
                obj.oriNameId = info.firm_subaccount_id;
                this.formData = {
                    newNameId: '',
                    ...obj
                };
            }
        },

        /**
         * 提交
         */

        submit() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            let {
                oriNameId,
                newNameId
            } = this.formData;
            if (oriNameId === '' || oriNameId === undefined || oriNameId === null) {
                this.toast('请先选择原销售');
                this.isSubmit = false;
                return;
            }
            if (newNameId === '' || newNameId === undefined || newNameId === null) {
                this.toast('请先选择新销售');
                this.isSubmit = false;
                return;
            }
            if (newNameId && oriNameId === newNameId) {
                this.toast('同一人下不允许进行资源转移操作');
                this.isSubmit = false;
                return;
            }
            let params = {
                id: this.info.id || '',
                old_sid: this.info.id ? '' : oriNameId || '',
                new_sid: newNameId,
                ...(this.transType === 1 || this.transType === 2) && {
                    trans_type: this.transType
                }
            };
            let url = URL.transferSubmit;
            // 会员权益接口
            if (this.transType === 3) {
                url = URL.utilTrans;
            }
            // 会员码页面
            else if (this.transType === 4) {
                url = URL.distributeSales;
            }
            this.$http({
                method: 'post',
                url,
                data: params
            }).then(res => {
                if (res && +res.code === 0) {
                    this.close();
                    this.toast(`${this.role}转移成功`);
                    this.$emit('updateList');
                    // 提交成功时，弹窗关闭需要时间，不再解锁，下次开启弹窗时再进行解锁
                    return;
                }
                this.isSubmit = false;
                this.toast(res && res.msg || '转移失败，请稍后重试');
            }).catch(err => {
                this.isSubmit = false;
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 查询关联人数
         */

        getRelativeCount() {
            let {
                oriNameId
            } = this.formData;
            if (!oriNameId) {
                return;
            }
            const params = {
                old_sid: oriNameId,
                crm_type: this.transType
            };
            this.$http.get(URL.gettranscnt, {
                params
            })
                .then(res => {
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        return;
                    }
                    let {cnt} = data;
                    this.relativeCount = cnt || 0;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                });
        },


        /**
         * 查询会员工具--销售成员下律师数量
         * @param {*} id
         */

        getVipToolCount(id) {
            if (!id) {
                return;
            }
            const params = {
                pn: 1,
                rn: 1,
                orderCreateTime: '',
                firm_subaccount_id: id
            };
            this.$http.get(URL.getVipList, {
                params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                this.relativeCount = res.count || 0;
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 查询会员码--销售成员下律师数量
         * @param {*} id
         */

        getCodeCount(id) {
            if (!id) {
                return;
            }
            const params = {
                pn: 1,
                rn: 1,
                firm_subaccount_id: id
            };
            this.$http.get(URL.getcode, {
                params
            }).then(res => {
                res = this.$normalizeResponseData(res);
                this.relativeCount = res.total || 0;
            }).catch(err => {
                this.$normalizeResponseError(err);
            });
        },

        /**
         * 原销售切换
         */

        oriNameChange(val) {
            let info = this.memberList.filter(item => {
                return item.id === val;
            })[0] || {};
            this.formData.oriName = info.name;
        },

        /**
         * 原销售切换
         */

        newNameChange(val) {
            let info = this.memberList.filter(item => {
                return item.id === val;
            })[0] || {};
            this.formData.newName = info.name;
        },

        /**
         * toast信息提示
         * @param {string} info 提示信息
         * @param {number} time 弹窗时间
         */

        toast(info, time = 2) {
            if (!info) {
                return;
            }
            let toast = {
                content: info,
                duration: time
            };
            this.$Message.info(toast);
        },

        /**
         * 关闭弹窗
         */

        close() {
            this.$emit('close');
        }
    }
};
</script>

<style lang="stylus" scoped>
.transfer-dialog
    .title-box
        width 100%
        font-family PingFangSC-Medium
        font-size 16px
        line-height 16px
        color #333
        display flex
        align-items center
        justify-content space-between
        margin-bottom 12px

        .title-text
            flex 1

        .close
            font-size 16px
            cursor pointer
            color #848b99

    /deep/.veui-dialog-content
        width 420px

        .veui-dialog-content-body
            .veui-field
                margin-bottom 16px
                .veui-field-label
                    width 60px
                    margin-right 17px
                    justify-content flex-start
                    .veui-label
                        font-family PingFangSC-Regular
                        font-size 14px
                        color #1e1f24
                        line-height 14px
                .veui-field-content
                    .veui-select
                        width 248px
                .veui-textarea
                    width 100%
            .result-tips
                display flex
                align-items center
                font-family PingFangSC-Regular
                font-size 14px
                color #333
                line-height 18px
                font-weight 400

                .result-title
                    margin-left 12px
                    flex-shrink 0

                .result
                    margin-left 10px
                .no-result
                    color #999
            .foot-button
                display flex
                justify-content flex-end
                align-items center
                margin-top 22px
                color #000

                .veui-button[ui~=strong]
                    color rgba(19, 22, 26, .9)

                .submit-btn
                    margin-left 10px
        /deep/.veui-dialog-content-foot
            display flex
            justify-content center
            .veui-button
                width 86px
                height 40px
                font-size 14px
                border-radius 5px
                border 1px solid rgba(59, 111, 255, 1)

</style>
